import React from 'react'

import * as Grid from '../../Grid'

import {
  Container,
  Title,
  SubTitle,
  Wrapper,
  Code,
  CreateAccountWrapper,
  Pre,
  CodeCustom,
  Details,
  Button,
  ButtonPrimary,
  ButtonSecondary
} from './style'

function CodeContainer() {
  return (
    <Grid.Container>
      <Grid.Row>
        <Grid.Column md={12}>
          <Container>
            <Title>An API Built For Developers by Developers</Title>
            <SubTitle>
              Our API is simple to use and well documented with a 24/7 email
              support.
            </SubTitle>
          </Container>
        </Grid.Column>
        <Grid.Column md={12}>
          <Wrapper>
            <Code>
              <Pre>
                <CodeCustom>
                  {`{
  "user_code":6971,
  "app_key":"1656d700707ad9a77f737e5df3db088a",
  "customer_email":"johndoe@email.com",
  "customer_password":"pass12345"
}
                  `}
                </CodeCustom>
              </Pre>
            </Code>

            <CreateAccountWrapper>
              <Details>
                With an easy-to-use API, you can integrate SkyPostal services
                into any website, free of charge!
              </Details>
              {/* <Button href="#create-account">Create Account</Button> */}
              {/* <ButtonPrimary href="#api-reference">API Reference</ButtonPrimary> */}
              {/* <ButtonSecondary href="https://www.skypostal.com/">
                Contact Us
              </ButtonSecondary> */}
              <Button
                href="https://www.skypostal.com/contact-us"
                target="_blank"
              >
                Contact Us
              </Button>
            </CreateAccountWrapper>
          </Wrapper>
        </Grid.Column>
      </Grid.Row>
    </Grid.Container>
  )
}

export default CodeContainer
